export const FilterFields = [
  {
    type: 'text',
    name: 'name',
    label: 'Permission name',
    value: ''
  }
];
